import {ScheduledEmailsFrequencyOptions} from './constants'
import {dateExpired} from "../../utils/utils";
import moment from "moment";

export function findIntermediatePointsByPrecedingDeliveryPoint(intermediatePointsSeries, deliveryPointPosition, deliveryPointType) {
  return intermediatePointsSeries.filter(series =>
    series.precedingDeliveryPoint?.type === deliveryPointType
    && series.precedingDeliveryPoint?.position === deliveryPointPosition
  )
    .flatMap(series => series.points)
}

export function findIntermediatePointsPriorFirstLoading(intermediatePointsSeries) {
  return intermediatePointsSeries.filter(series => series.precedingDeliveryPoint === null)
    .flatMap(series => series.points)
}

// this function assumes that intermediate points of the order are already sorted by appearance in order
// and position is valid in context of the order
export function findNumberOfIntermediatePointAtPosition(order, position) {
  const precedingDeliveryPoint = position.precedingDeliveryPoint
  const pointsWithinSeries = precedingDeliveryPoint === null
    ? findIntermediatePointsPriorFirstLoading(order.intermediatePoints)
    : findIntermediatePointsByPrecedingDeliveryPoint(order.intermediatePoints,
      precedingDeliveryPoint.position, precedingDeliveryPoint.type)
  const point = pointsWithinSeries[position.intermediateIndex]
  return order.intermediatePoints.flatMap(series => series.points)
    .filter(p => p.type === point.type)
    .indexOf(point) + 1
}

export const scheduledEmailsFrequencyOptionFromEmailNotificationSettings = emailNotificationSettings => {
  const {frequencySettingsType, sendIntervalHours} = emailNotificationSettings
  return Object.values(ScheduledEmailsFrequencyOptions).find(opt =>
    opt.frequencySettingsType === frequencySettingsType
    && opt.sendIntervalHours === sendIntervalHours) || ScheduledEmailsFrequencyOptions.Never
}

export const orderVerificationWarningsInit = {
  noVerification: false,
  noHvVerification: false,
  carrierVerificationExpirationDate: false,
  hvExpirationDate: false,
}

export const orderVerificationWarnings = (client, carrier, orderHV, loadingDeliveryPoints, unloadingDeliveryPoints, carrierVerificationValidityAfterDischargeSetting) => {
  let verificationWarnings = {...orderVerificationWarningsInit}

  if (client && carrier) {
    if (client.requireCarrierVerifiedBasic) {
      if (!carrier.carrierVerificationExpirationDate && !carrier.hvExpirationDate) {
        verificationWarnings.noVerification = true
      }
    }
    if (client.requireCarrierVerifiedHV || orderHV) {
      if (!carrier.hvExpirationDate) {
        verificationWarnings.noHvVerification = true
      }
    }
  }

  if (client && carrier && unloadingDeliveryPoints && carrierVerificationValidityAfterDischargeSetting) {
    if (unloadingDeliveryPoints.length) {
      const verificationValidityDate = moment.max(unloadingDeliveryPoints.map(point => moment(point.toDateTime || point.deliveryPointDetails?.toDate)))
      verificationValidityDate.add(carrierVerificationValidityAfterDischargeSetting, 'day')
      if (client.requireCarrierVerifiedBasic) {
        if (dateExpired(carrier.carrierVerificationExpirationDate, verificationValidityDate) && dateExpired(carrier.hvExpirationDate, verificationValidityDate)) {
          verificationWarnings.carrierVerificationExpirationDate = true
        }
      }
      if (client.requireCarrierVerifiedHV || orderHV) {
        if (dateExpired(carrier.hvExpirationDate, verificationValidityDate)) {
          verificationWarnings.hvExpirationDate = true
        }
      }
    }
  }
  return verificationWarnings
}
